import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { Polygon, MultiPolygon, Feature, Position } from 'geojson';
import { DeclareMethod } from '/imports/methods';

export interface BuildingFootprint extends Feature<Polygon> {
  _id: string;
  area?: number;
  centroid?: Position;
}

export const BuildingFootprints = new Mongo.Collection<BuildingFootprint>('buildingFootprints');

export const listFootprintsInPolygon = DeclareMethod<{
  polygon: Polygon;
}, BuildingFootprint[]>('listFootprintsInPolygon');

export interface FootprintEnrichment {
  addressString: string;
  primaryType?: string;
  displayName?: string;
  footprintArea?: number;
  displayPolygon?: Polygon | MultiPolygon;
}

export const geocodeFootprint = DeclareMethod<{
  centroid: Position;
}, FootprintEnrichment | undefined>('geocodeFootprint');

export const staticMapImage = DeclareMethod<{
  lat: number;
  lng: number;
}, string | undefined>('staticMapImage');

Meteor.isServer && Meteor.startup(async () => {
  await BuildingFootprints.createIndexAsync({ geometry: '2dsphere' });
});
